import { Button, ButtonProps, Icon } from '@innovationnorway/cl-react';
import React from 'react';
import DialogContainer from 'src/components/DialogContainer/DialogContainer';
import useToggle from 'src/hooks/use-toggle';

export interface AddEntityModalButtonProps {
  buttonText: React.ReactNode;
  buttonColor?: ButtonProps['data-color'];
  buttonVariant?: ButtonProps['variant'];
  /** Font Awesome sharp-regular icon name, e.g. "plus" */
  buttonIcon?: string;

  onClick?: () => void;
  onSuccess?: () => void;

  disabled?: boolean;

  modalTitle: string;
}

const AddEntityModalButton: React.FC<React.PropsWithChildren<AddEntityModalButtonProps>> = ({
  buttonText,
  buttonColor,
  buttonVariant = 'primary',
  buttonIcon,
  onClick,
  onSuccess,
  disabled,
  modalTitle,
  children,
}) => {
  const { isActive, activate, deactivate } = useToggle(false);

  const childrenArray = React.Children.toArray(children);
  const onClose = () => {
    deactivate();
  };

  return (
    <>
      <Button
        type="button"
        data-color={buttonColor}
        variant={buttonVariant}
        onClick={() => {
          activate();
          onClick?.();
        }}
        disabled={disabled}
      >
        {buttonIcon && <Icon prefix="fasr" iconName={buttonIcon} />}
        {buttonText}
      </Button>

      <DialogContainer show={isActive} onClose={deactivate} title={modalTitle}>
        {childrenArray.map((child) =>
          React.cloneElement(child as React.ReactElement<any>, { onClose, onSuccess }),
        )}
      </DialogContainer>
    </>
  );
};

export default AddEntityModalButton;
